<mat-card>
  <mat-card-title>
    Sign-in
  </mat-card-title>
  
  <form class="login-form" [formGroup]="loginForm">
    <p>
      <mat-form-field class="full-width-field">
        <mat-label>User Name</mat-label>
        <input matInput formControlName="userName" placeholder="User Name">
      </mat-form-field>
    </p>
    <p>
      <mat-form-field class="full-width-field">
        <mat-label>Password</mat-label>
        <input matInput  [type]="hide ? 'password' : 'text'" formControlName="password">
        <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
      </mat-form-field>
    </p>
    <div class="text-right">
      <a [routerLink]="'/forgot-password'">
        Forgot Password?
      </a>
      <br>
      <button class="mt-5 mr-2" mat-raised-button   color="primary" [routerLink]="'/register'">
        Sign Up
      </button>
      <button class="mt-5" mat-raised-button  style="background-color: white; color: blue;" (click)="submit()">
        Sign in
      </button>
    </div>
    <div style="margin-top: 10px;">
      <span  (click)="goToTerms()" style="margin-top: 10px; cursor: pointer; text-decoration: underline; color: #007bff;">
        Provider Terms
      </span>
    </div>
  
  </form>

</mat-card>